export interface Errors {
    [key: string]: string | undefined;
}

export interface GroupsInterface {
    value: string,
    label: string
}


export interface UserDetails {
    userName: string,
    email: string,
    password: string,
    groupName: string,
    selectedApps: [],
    permissions: []
}

export const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};



export const isValidPassword = (password: string): boolean => {
    return password.trim().length > 8
}